import React, { Component } from 'react'

import DOOgether from 'Assets/logo/doogether.png'

export default class NotFound extends Component {
	render() {
		return (
			<div className='error'>
				<img src={DOOgether} alt='doogether' />
			</div>
		)
	}
}
